import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08aa0ec0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.link,
    target: "_new"
  }, [
    _createElementVNode("button", {
      class: _normalizeClass(_ctx.styleButton()),
      style: _normalizeStyle(_ctx.btnOptions),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (this.resetMenu(this.text)))
    }, _toDisplayString(_ctx.text), 7)
  ], 8, _hoisted_1))
}